import React, { ReactNode, createContext, useContext } from 'react';

type AppContextType = {
  siteId: number;
  siteSlug: string;
};

const AppContext = createContext<Partial<AppContextType>>({});

export function AppProvider({ value, children }: { value: AppContextType; children: ReactNode }) {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext(): AppContextType {
  const { siteId, siteSlug } = useContext(AppContext);

  if (!siteId || !siteSlug) {
    throw new Error('siteId and siteSlug must be set in AppContext');
  }

  return {
    siteId,
    siteSlug,
  };
}
